import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectApi(data) {
  return request({
    url: `/admin/checkInRecord/select`,
    method: "POST",
    data,
  });
}


/*删除 */
export function deleteApi(data) {
  return request({
    url: `/admin/checkInRecord/delete`,
    method: "POST",
    data,
  });
}
